// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-white-opacity{background-color:hsla(0,0%,100%,.863)}", ""]);
// Exports
module.exports = exports;
